/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const modeOfTransportTrav = async (): Promise<any> => {
  const modeOfTransportTrav = useJSONStore.getState().modeOfTransportTrav;
  const token = useUserStore.getState().userToken;
  const setModeOfTransport = useJSONStore.getState().setModeOfTransportTrav;

  if (modeOfTransportTrav.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.modeOfTransportByTravel}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setModeOfTransport(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default modeOfTransportTrav;
